import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezxwqwpffr: FaireProductEntity = {
  token: "p_ezxwqwpffr",
  type: "product",
  name: "S925 Silver 14k Gold Plated Cute Heart Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f9c812ade6c2f9cbf8715b20de2f8adce34b5474c49c659d560b0605fa96259b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19901f0620417ccc0aa36d7cffead28fdb5446270056d4b01011b9a648de4f6f.jpeg",
    "https://cdn.faire.com/fastly/2e9ec9d3a7b356b54c2526634614a86d817a69beedd364cc40d1239e8bdd6a9e.jpeg",
    "https://cdn.faire.com/fastly/b2dd1c06014c3fa7f719f1eec16bf269ba3a7b39ab7545ceeade05a15133b444.jpeg",
  ],
  priceDollars: 10.4,
  description:
    "-Meticulously crafted from premium sterling silver (S925), this ring embodies timeless elegance and artisanal craftsmanship, and let this handcrafted ring become a symbol of your refined taste and sophistication.\n-ID: GIORI24047\n-Material: S925 Silver\n-Stone(s): Cubic Zirconia\n-Size: 5,6,7,8 (Standard US Size)\n-Weight(s): 1g\n-Quality: Excellent\n-Lead Free, -Nickel Free",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:35.570Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
